<template>
    <div class="flex flex-col items-center">
        <div v-if="!hideBorder" class="w-full border-t pb-40"></div>
        <div class="grid grid-cols-3 gap-16">
            <div class="col-span-2">
                <h3 class="font-semibold text-[11pt] mb-15">{{ $t('settings.integrations.seek.discover_title') }}</h3>
                <p class="mb-15" v-html="$t('settings.integrations.seek.discover_body')"></p>
            </div>
            <img class="h-200 min-w-min" src="/app/img/seek-logo.png"/>
        </div>
    </div>
</template>

<script>
import SimpleButton from "../ui/SimpleButton.vue";
import SvgIcon from '../ui/SvgIcon.vue';

export default {
    name: 'SeekDiscover',
    components: { SimpleButton, SvgIcon },
    props: {
        hideBorder: {
            type: Boolean,
            default: false
        },
    },
};
</script>
